<template>
    <v-container grid-list-xl>
        <v-layout wrap justify-space-between>
            <v-flex xs12 md12>
                <h1>핸드폰 비번 찾기 완료</h1>
                <h1>Password Recovery Success</h1>
                <br /><v-btn to="/profile/login"> 다음 / Continue </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {
    phone_countries,
    country_abbreviation_to_country_code,
} from "@/settings";
export default {
    props: ["auth"],
    data: () => ({
        success: false,
    }),
    beforeMount: async function() {},
    watch: {},
    computed: {},
    methods: {},
};
</script>
<style scoped></style>
